module.exports = require("xml");


//////////////////
// WEBPACK FOOTER
// external "xml"
// module id = 603
// module chunks = 0